import * as React from 'react';

const buyerIntentSignalSmall = (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 5C0 2.23858 2.23858 0 5 0H15C17.7614 0 20 2.23858 20 5V15C20 17.7614 17.7614 20 15 20H5C2.23858 20 0 17.7614 0 15V5Z" fill="white"/>
    <circle cx="15.5714" cy="16.3807" r="2.42857" fill="url(#paint0_linear_23086_12761)"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1424 6.97328C13.1169 5.3972 12.4794 3.89284 11.3647 2.7783C10.2261 1.63967 8.68175 1 7.07149 1C5.46123 1 3.91692 1.63967 2.7783 2.7783C1.63967 3.91692 1 5.46123 1 7.07149C1 8.68175 1.63967 10.2261 2.7783 11.3647L5.64133 14.227L5.73847 14.3181C6.12477 14.6564 6.6252 14.8352 7.13838 14.8182C7.65157 14.8013 8.13914 14.59 8.50233 14.227L11.3647 11.3654L11.5016 11.2237C12.5796 10.0736 13.168 8.54936 13.1424 6.97328ZM7.07145 8.42094C8.18918 8.42094 9.09527 7.51484 9.09527 6.39712C9.09527 5.2794 8.18918 4.3733 7.07145 4.3733C5.95373 4.3733 5.04763 5.2794 5.04763 6.39712C5.04763 7.51484 5.95373 8.42094 7.07145 8.42094Z" fill="url(#paint1_linear_23086_12761)"/>
    <g style={{ mixBlendMode: 'multiply' }}>
    <circle cx="11.9284" cy="12.7385" r="5.2619" fill="url(#paint2_linear_23086_12761)"/>
    </g>
    <defs>
    <linearGradient id="paint0_linear_23086_12761" x1="17.2354" y1="18.0236" x2="11.224" y2="15.7974" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_23086_12761" x1="11.2318" y1="12.5839" x2="-4.22197" y2="7.55513" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint2_linear_23086_12761" x1="11.9284" y1="7.47656" x2="13.5475" y2="20.0242" gradientUnits="userSpaceOnUse">
    <stop stop-color="#7DC4FF"/>
    <stop offset="1" stop-color="#FFE7AB" stop-opacity="0"/>
    </linearGradient>
    </defs>
    </svg>
     
);

export default buyerIntentSignalSmall;
